import { Box, Typography } from "@mui/material"
import type { SxProps, Theme } from "@mui/material"
import { visuallyHidden } from "@mui/utils"
import { DropTarget } from "components/upload/components/drop-target"
import { MAX_ATTACHMENT_BYTES, MAX_ATTACHMENT_COUNT } from "./attachments-config"

const OVERLAY_SX = {
  position: "absolute",
  inset: 0,
  zIndex: 3,
  p: 1.5,
  pointerEvents: "none",
  bgcolor: "color-mix(in srgb, var(--mui-palette-background-paper) 90%, transparent)",
} satisfies SxProps<Theme>

const ANNOUNCEMENT = "Drop files to attach them to your message"
const LIMITS_HINT = `Up to ${MAX_ATTACHMENT_COUNT} files, ${MAX_ATTACHMENT_BYTES / (1024 * 1024)} MB each`

export function DockDropOverlay({ isActive }: { isActive: boolean }) {
  return (
    <>
      <Box role="status" sx={visuallyHidden} data-testid="kelly-dock-drop-status">{isActive ? ANNOUNCEMENT : ""}</Box>
      {isActive && (
        <Box sx={OVERLAY_SX} aria-hidden data-testid="kelly-dock-drop-overlay">
          <DropTarget isActive>
            <Typography variant="subtitle1" component="p">{ANNOUNCEMENT}</Typography>
            <Typography variant="body2" component="p">{LIMITS_HINT}</Typography>
          </DropTarget>
        </Box>
      )}
    </>
  )
}
